<template>
    <div>
        <FormInput label="CÓDIGO QR" v-model="abonado.qr_code" />
        <FormInput label="DNI - PASAPORTE - NIE" v-model="abonado.dni" />
        <FormInput class="mb-3 mb-lg-4" label="Nº DE ABONADO" v-model="abonado.n_abonado" />

        <button @click.prevent="terminar" class="button large-button effect-button"><span>Buscar</span></button>
    </div>    
</template>

<script>
    export default {
        props: ['abonado'],
        data() {
            return {
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                this.terminar();
                if(isValid) {
                    this.terminar();
                }
            },
            terminar() {
                this.$emit('terminado');
            }
        },
    }
</script>

<style>

</style>
